import { ILogger } from 'shared/types';

interface Args {
    logger: ILogger;
    eventInfo: string;
}

export const trackEvent = ({ logger, eventInfo }: Args) => {
    const KLTrackEvent = window.KLTrackEvent;

    if (typeof KLTrackEvent !== 'undefined' && typeof KLTrackEvent === 'function') {
        logger.log(`Sending event to GTM: ${eventInfo}`);
        KLTrackEvent(eventInfo);
    } else {
        logger.error(
            `KLTrackEvent helper function is missing. Can't send event ${eventInfo} to GTM`,
        );
    }
};
